<div class="layout-container" [ngClass]="containerClass">
    <app-sidebar></app-sidebar>
    <div class="layout-content-wrapper">
        <app-topbar></app-topbar>
        <app-breadcrumb class="content-breadcrumb"></app-breadcrumb>
        <div class="layout-content">
            <router-outlet></router-outlet>
        </div>
        <!-- <div class="col-12 md:flex-row gap-5">
            <hr>
            <span style="height: 30px;" class="text-700 block text-center"><strong>Italset S.r.l.</strong> Via Giuseppe
                Sansonetti, 20 - Casarano (LE) - 73042 - CF e P.IVA 03890260759<br><a
                    [routerLink]="['/cookie-policy']">Privacy Policy | Cookie Policy</a></span>
        </div> -->
        <app-bottombar></app-bottombar>
    </div>
    <app-supportmenu></app-supportmenu>
    <app-profilemenu></app-profilemenu>
    <app-config></app-config>
    <div class="layout-mask"></div>
</div>